import { lazy, useEffect } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { Routes, SyncHook } from '../route-types';
import { authService } from 'redux/utils/auth/auth-service';

// Lazy load the NoAccessPage component
const NoAccessPage = lazy(() =>
  import('../no-access-page').then(module => ({
    default: module.default,
  }))
);

export const NO_ACCESS_PREFIX_PATH = '/no-access';

const useSyncHook: SyncHook = () => {
  useEffect(() => {
    // Set a timeout to log the user out after 10 seconds
    const timeoutId = setTimeout(() => {
      void authService.logout();
    }, 10000);

    // Cleanup timeout on unmount
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);
};

const routes: Routes = [{ path: '/no-access', element: <NoAccessPage /> }];

const useNavigationHooks = () => {
  const navigate = useNavigate();
  return {
    toNoAccess: (options?: NavigateOptions) => {
      navigate(NO_ACCESS_PREFIX_PATH, options);
    },
  };
};

export const noAccessPageRouteConfig = {
  routes,
  useSyncHook,
  publicRoute: true, // This should be public so users can access it without authentication
  useNavigationHooks,
};
